import { HttpContextToken } from '@angular/common/http';

export const EXCLUDE_ERRORS = new HttpContextToken<number[]>(() => []);
